import { render } from "./ChooseBatteryBrands.vue?vue&type=template&id=49790c68"
import script from "./ChooseBatteryBrands.vue?vue&type=script&lang=js"
export * from "./ChooseBatteryBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__